import { SolanaWithoutSignerBaseCommand } from '../../../../solana';
import { chalkString } from '../../../../utils';

import { web3 } from '@coral-xyz/anchor';
import { Args } from '@oclif/core';
import { toUtf8 } from '@switchboard-xyz/common';
import { Oracle, OracleAccountData } from '@switchboard-xyz/on-demand';

export default class OraclePrint extends SolanaWithoutSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'print a oracle account';

  static flags = {
    ...SolanaWithoutSignerBaseCommand.flags,
  };

  static args = {
    oracleKey: Args.string({
      description: 'public key of the oracle account',
      required: true,
    }),
  };

  async run() {
    const { args } = await this.parse(this.constructor as typeof OraclePrint);

    const program = await this.program;

    const oraclePubKey = new web3.PublicKey(args.oracleKey);

    const oracleAccount = new Oracle(program, oraclePubKey);
    const oracle = await oracleAccount.loadData();

    console.log(
      this.printOracleRecap(
        oracleAccount.pubkey,
        oracle,
        // ataPubkey,
        // rewardBalance,
        // switchPubkey,
        // switchRewardBalance,
        36
      )
    );
  }

  printOracleRecap(
    publicKey: web3.PublicKey,
    oracle: OracleAccountData,
    // rewardAddress: web3.PublicKey,
    // rewardBalance: number,
    // switchRewardAddress: web3.PublicKey,
    // switchRewardBalance: number,
    SPACING = 36
  ): string {
    this.normalizeAccountData(publicKey, oracle);

    const output: string[] = [];

    output.push('', chalkString('## Oracle Data', '', SPACING));
    output.push(chalkString('Oracle PubKey', publicKey, SPACING));
    output.push(chalkString('authority', oracle.authority, SPACING));
    output.push(chalkString('queue', oracle.queue, SPACING));
    output.push(
      chalkString(
        'gatewayUri',
        Buffer.from(oracle.gatewayUri).toString('utf8').replace(/\0/g, ''),
        SPACING
      )
    );

    output.push(
      chalkString(
        'createdAt',
        new Date(oracle.createdAt.toNumber() * 1000).toISOString(),
        SPACING
      )
    );
    output.push(
      chalkString(
        'lastHeartbeat',
        new Date(oracle.lastHeartbeat.toNumber() * 1000).toISOString(),
        SPACING
      )
    );

    // output.push(chalkString("rewardAddress", rewardAddress, SPACING));
    // output.push(chalkString("rewardBalance", rewardBalance, SPACING));
    //
    // output.push(
    // chalkString("switchRewardAddress", switchRewardAddress, SPACING)
    // );
    // output.push(
    // chalkString("switchRewardBalance", switchRewardBalance, SPACING)
    // );

    output.push(chalkString('permissions', oracle.permissions, SPACING));
    output.push(chalkString('isOnQueue', Boolean(oracle.isOnQueue), SPACING));

    output.push('', chalkString('## Enclave Info', '', SPACING));

    const quote = oracle.enclave;
    output.push(chalkString('enclaveSigner', quote.enclaveSigner, SPACING));
    output.push(
      chalkString(
        'mrEnclave',
        `0x${Buffer.from(quote.mrEnclave).toString('hex')}`,
        SPACING
      )
    );

    output.push(
      chalkString('verificationStatus', quote.verificationStatus, SPACING)
    );
    output.push(
      chalkString(
        'verificationTimestamp',
        new Date(
          quote.verificationTimestamp.muln(1000).toNumber()
        ).toISOString(),
        SPACING
      )
    );
    output.push(
      chalkString(
        'validUntil',
        new Date(quote.validUntil.muln(1000).toNumber()).toISOString(),
        SPACING
      )
    );
    output.push(
      chalkString('quoteRegistry', toUtf8(quote.quoteRegistry), SPACING)
    );
    output.push(chalkString('registryKey', toUtf8(quote.registryKey), SPACING));

    output.push(
      chalkString(
        'secp256k1Signer',
        `0x${Buffer.from(quote.secp256K1Signer).toString('hex')}`,
        SPACING
      )
    );
    output.push(
      chalkString('lastEd25519Signer', quote.lastEd25519Signer, SPACING)
    );
    output.push(
      chalkString(
        'lastSecp256k1Signer',
        `0x${Buffer.from(quote.lastSecp256K1Signer).toString('hex')}`,
        SPACING
      )
    );
    output.push(chalkString('lastRotateSlot', quote.lastRotateSlot, SPACING));

    output.push(
      chalkString(
        'guardianApproversLen',
        quote.guardianApproversLen.toString(),
        SPACING
      )
    );
    output.push(chalkString('guardianApprovers', '', SPACING));
    for (let i = 0; i < quote.guardianApproversLen; i++) {
      output.push(
        chalkString(
          `    guardianApprover-${i}`,
          quote.guardianApprovers[i],
          SPACING
        )
      );
    }

    // Additional fields should be added to output before the line below
    // which will print all lines, separated by new line.
    return output.join('\n');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to print oracle');
  }
}
